import { AuthConstant } from '../constants'

const initialState = {
  authenticated: false,
  token_expired: false,
  show_max_num_and_survey: false,
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case AuthConstant.AUTHENTICATE:
      return {
        ...state,
        authenticated: action.payload.authenticated
      };
    case AuthConstant.TOKEN_EXPIRED:
      return {
        ...state,
        token_expired: action.payload.token_expired
      };
    case AuthConstant.SHOW_MAX_NUM_AND_SURVEY:
      return {
        ...state,
        show_max_num_and_survey: !!action.payload
      };
    case AuthConstant.CHECKING_REDIRECTION:
      return {
        ...state,
        checking_redirection: action.payload.checking_redirection
      };
    default:
      return state;
  }
}
